<template>
    <x-page :title="pageTitle">
        <template #header-actions>
            <x-back-button :disabled="isLoading" :display-warning="false" />
        </template>
        <group-category-form id="group-category-form"
            v-if="resource"
            :disabled="true"
            :initialFields="resource" />
    </x-page>
</template>

<script>
import XBackButton from '../../components/XBackButton.vue'
import XPage from '../../components/XPage.vue'
import { handleGeneralXhrError } from '../../helpers'
import GroupCategoryForm from './GroupCategoryForm.vue'

export default {
    components: {
        XPage,
        XBackButton,
        GroupCategoryForm,
    },
    computed: {
        pageTitle() {
            return `Kategori Group | ${this.resource?.label}`
        }
    },
    created() {
        this.fetchResource()
    },
    data() {
        return {
            errors: null,
            isLoading: false,
            resource: null,
        }
    },
    methods: {
        fetchResource() {
            this.isLoading = true
            const request = axios.get(`/api/group-categories/${this.$route.params.id}`, {
                params: {
                    append: ['enter_trigger', 'exit_trigger'],
                }
            })
            .then(response => {
                this.resource = response.data.data;
                if (this.resource.enter_trigger) {
                    this.resource.enter_trigger.active = true;
                }
                if (this.resource.exit_trigger) {
                    this.resource.exit_trigger.active = true;
                }
            })
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false
            })
        },
    },
}
</script>